import worldAbi from "../../contracts/out/IWorld.sol/IWorld.abi.json";

import {IWorldAbi} from "@eveworld/contracts"

export const chainId = parseInt(import.meta.env.VITE_CHAIN_ID) || 695569;
export const worldAddress = import.meta.env.VITE_WORLD_ADDRESS;

const abi = worldAbi.concat(IWorldAbi.abi)
//console.log(abi);

abi.push({    
    "type": "function",
    "name": "eveworld__setEntityMetadata",
    "inputs": [
        {
            "type": "uint256"
        },
        {
            "type": "string"
        },
        {
            "type": "string"
        },
        {
            "type": "string"
        }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"    
});

abi.push({    
    "type": "function",
    "name": "eveworld__configureSmartGate",
    "inputs": [
        {
            "type": "uint256"
        },
        {
            "type": "bytes32"
        }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"    
});

abi.push({    
    "type": "function",
    "name": "eveworld__configureSmartTurret",
    "inputs": [
        {
            "type": "uint256"
        },
        {
            "type": "bytes32"
        }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"    
});

abi.push({    
    "type": "function",
    "name": "REAP__balanceOf",
    "inputs": [
        {
            "type": "address"
        },
    ],
    "outputs": [
        {        
            "type": "uint256",
        }
    ],
    "stateMutability": "nonpayable"    
});

export { abi as worldAbi };
